import { TableHeader } from '@tiptap/extension-table';
import {
  borderEdgeStyleAttributes,
  borderEdgeWeightAttributes,
  offsetCellAttribute,
} from '../nodes/table/borderAttributes';
import { alignAttribute, textRotationAttribute, verticalAlignAttribute } from '../nodes/table/cellAttributes';

const CustomTableHeader = TableHeader.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      ...alignAttribute(),
      ...textRotationAttribute(),
      ...verticalAlignAttribute(),
      ...offsetCellAttribute(),
      ...borderEdgeStyleAttributes(),
      ...borderEdgeWeightAttributes(),
    };
  },
});

export default CustomTableHeader;
